import React from "react";
import { Link } from "react-router-dom";
import { Check } from "@mui/icons-material";
import img1 from "../Assets/1.png";
import img2 from "../Assets/2.png";
import img3 from "../Assets/33.png";
import img4 from "../Assets/4.png";

function Premium() {
  return (
    <div>
      <div className="bg-blue-600 px-3 pt-7 pb-6 flex flex-col gap-y-6 sm:gap-9 md:pt-12 md:pl-6 lg:gap-10 lg:pt-14 lg:pl-14 lg:pb-8 xl:pt-16 xl:pl-28">
        <div className="text-white flex flex-col gap-y-4 pt-2 md:gap-8">
          <h1 className="font-extrabold text-2xl sm:text-3xl md:text-4xl md:font-black">
            Get Premium free for 1 month
          </h1>
          <p className="font-semibold text-lg md:text-xl">
            Just ₦ 900/month after. Cancel anytime.
          </p>
        </div>
        <div className="grid gap-3 w-[100%] md:grid-cols-2 md:w-[45%] lg:w-[31%] ">
          <button className=" bg-black text-white px-5 py-4 sm:py-4 md:py-3 rounded-3xl text-sm font-semibold uppercase hover:transform translate duration-800 hover:scale-110">
            <Link to="/"> Get Started</Link>
          </button>
          <button className="text-white px-5 py-3 sm:py-4 md:py-3 rounded-3xl border-2 text-sm font-semibold uppercase hover:transform translate duration-800 hover:scale-110 hover:bg-blue-700">
            <Link to="/">View Plans</Link>
          </button>
        </div>
        <p className="text-white font-medium text-[0.6rem] leading-relaxed sm:text-xs lg:text-[0.6rem]">
          <span className="underline cursor-pointer mr-1">
            <Link to="/">Terms and conditions apply.</Link>
          </span>
          1 month free not available for users who already have premium
        </p>
      </div>

      <div className="py-8 md:py-20 md:px-4 xl:py-30">
        <div className="text-center text-3xl font-bold md:text-4xl md:font-extrabold">
          Why Premium?
        </div>

        <div className="flex flex-col mt-8 gap-y-8 md:grid md:grid-cols-2 md:gap-y-2 xl:grid-cols-4 xl:mt-14 xl:px-32">
          <div className="flex gap-6 items-center px-4 md:my-6 xl:flex-col xl:items-center xl:text-center">
            <div>
              <img
                src={img1}
                alt="music-note"
                className="w-[90px] lg:w-[110px]"
              />
            </div>

            <div>
              <h2 className="font-bold mb-2">Download music.</h2>
              <p className="text-sm font-medium">Listen anywhere.</p>
            </div>
          </div>

          <div className="flex gap-6 items-center px-4 md:my-6 xl:flex-col xl:items-center xl:text-center">
            <div>
              <img
                src={img2}
                alt="music-note"
                className="w-[100px] lg:w-[110px]"
              />
            </div>

            <div>
              <h2 className="font-bold mb-2">Ad-free music listening.</h2>
              <p className="text-sm font-medium">Enjoy uninterrupted music.</p>
            </div>
          </div>

          <div className="flex gap-6 items-center px-4 md:my-6 xl:flex-col xl:items-center xl:text-center">
            <div>
              <img
                src={img3}
                alt="music-note"
                className="w-[100px] lg:w-[110px]"
              />
            </div>

            <div>
              <h2 className="font-bold mb-2">Play songs in any order.</h2>
              <p className="text-sm font-medium">Any song, any order.</p>
            </div>
          </div>
          <div className="flex gap-6 items-center px-4 md:my-6 xl:flex-col xl:items-center xl:text-center">
            <div>
              <img
                src={img4}
                alt="music-note"
                className="w-[90px] lg:w-[120px]"
              />
            </div>

            <div>
              <h2 className="font-bold mb-2">Higher sound quality.</h2>
              <p className="text-sm font-medium">Feel the sound.</p>
            </div>
          </div>
        </div>
      </div>

      <div className="bg-gray-100 py-10 xl:pb-20">
        <div className="mb-14 text-center">
          <h1 className="font-extrabold text-2xl md:text-4xl md:font-extrabold md:mt-12">
            Pick your Premium
          </h1>
          <p className="px-4 text-sm font-medium">
            Listen without limits on your phone, speaker, and other devices.
          </p>
        </div>

        <div className="px-3 space-y-4 xl:space-y-0 sm:w-[30rem] sm:space-y-6 md:w-[35rem] lg:w-[38rem] block m-auto xl:grid xl:grid-cols-4 xl:w-[80rem] xl:gap-3">

          <div className="bg-white flex flex-col gap-y-6 lg:gap-y-10 xl:gap-y-4 py-5 px-5 border-2 border-solid rounded-xl shadow-2xl lg:shadow-xs xl:h-[33rem]">
            <div>
              <div className="flex flex-col gap-1 text-sm sm:flex-row md:gap-2 lg:flex-col">
                <p className="w-fit bg-blue-700 text-white font-semibold p-1 rounded-md ">
                  1 month free with subscription
                </p>
                <p className="w-fit text-blue-700 font-semibold p-1 border-blue-700 border-solid border-[.1rem] rounded-md ">
                  Prepaid plans available
                </p>
              </div>

              <div className="font-medium text-sm flex flex-col gap-y-[.1rem] py-4">
                <h1 className="font-bold text-lg">Individual</h1>
                <p>₦ 900/month after offer period</p>
                <p>1 account</p>
              </div>

              <hr className="border-[0.1rem] border-gray-600 drop-shadow-xl opacity-70" />
            </div>

            <div className="flex flex-col justify-center gap-2 font-medium text-sm xl:pt-3 xl:pb-[3.6rem]">
              <span className="flex flex-row items-center gap-x-4">
                <div>
                  <Check />
                </div>
                Ad-free music listening
              </span>

              <span className="flex flex-row items-center gap-x-4">
                <div>
                  <Check />
                </div>
                Play anywhere - even offline
              </span>

              <span className="flex flex-row items-center gap-x-4">
                <div>
                  <Check />
                </div>
                Play songs in any order
              </span>
            </div>

            <div className="flex flex-col gap-y-4">
              <button className="w-full bg-black text-white px-5 py-3 sm:py-4 md:py-3 rounded-3xl text-sm font-semibold uppercase hover:transform translate duration-800 hover:scale-105">
                <Link to="/"> Get Started</Link>
              </button>

              <p className="text-black font-medium text-xs sm:text-xs lg:text-[0.6rem]">
                <span className="underline cursor-pointer mr-1">
                  <Link to="/">Terms and conditions apply.</Link>
                </span>
                1 month free not available for users who already have premium
              </p>
            </div>
          </div>

          <div className="bg-white flex flex-col gap-y-6 lg:gap-y-10 xl:gap-y-4 py-5 px-5 border-2 border-solid rounded-xl shadow-2xl lg:shadow-xs xl:h-[33rem]">
            <div>
              <div className="flex flex-col gap-1 text-sm sm:flex-row md:gap-2 lg:flex-col">
                <p className="w-fit bg-blue-700 text-white font-semibold p-1 rounded-md ">
                  1 month free
                </p>
              </div>

              <div className="font-medium text-sm flex flex-col gap-y-[.1rem] py-4">
                <h1 className="font-bold text-lg">Duo</h1>
                <p>₦ 1,200/month after offer period</p>
                <p>2 accounts</p>
                <p className="hidden xl:block w-fit text-white font-semibold p-2 border-solid border-transparent border-[.1rem] rounded-md ">
                  Prepaid plans available
                </p>
              </div>

              <hr className="border-[0.1rem] border-gray-600 drop-shadow-xl opacity-70" />
            </div>

            <div className="flex flex-col justify-center gap-2 font-medium text-sm xl:pt-3 xl:pb-14">
              <span className="flex flex-row items-center gap-x-4">
                <div>
                  <Check />
                </div>
                2 Premium accounts for a couple under one roof
              </span>

              <span className="flex flex-row items-center gap-x-4">
                <div>
                  <Check />
                </div>
                Ad-free music listening, play offline, play songs in any order
              </span>
            </div>

            <div className="flex flex-col gap-y-4">
              <button className="w-full bg-black text-white px-5 py-3 sm:py-4 md:py-3 rounded-3xl text-sm font-semibold uppercase hover:transform translate duration-800 hover:scale-105">
                <Link to="/"> Get Started</Link>
              </button>

              <p className="text-black font-medium text-xs sm:text-xs lg:text-[0.6rem]">
                <span className="underline cursor-pointer mr-1">
                  <Link to="/">Terms and conditions apply.</Link>
                </span>
                1 month free not available for users who already have premium
              </p>
            </div>
          </div>

          <div className="bg-white flex flex-col gap-y-6 lg:gap-y-10 xl:gap-y-4 py-5 px-5 border-2 border-solid rounded-xl shadow-2xl lg:shadow-xs xl:h-[33rem]">
            <div>
              <div className="flex flex-col gap-1 text-sm sm:flex-row md:gap-2 lg:flex-col">
                <p className="w-fit bg-blue-700 text-white font-semibold p-1 rounded-md ">
                  1 month free
                </p>
              </div>

              <div className="font-medium text-sm flex flex-col gap-y-[.1rem] py-4">
                <h1 className="font-bold text-lg">Family</h1>
                <p>₦ 1,400/month after offer period</p>
                <p>Up to 6 accounts</p>
                <p className="hidden xl:block w-fit text-white font-semibold p-2 border-solid border-transparent border-[.1rem] rounded-md ">
                  Prepaid plans available
                </p>
              </div>

              <hr className="border-[0.1rem] border-gray-600 drop-shadow-xl opacity-70" />
            </div>

            <div className="flex flex-col justify-center gap-2 xl:gap-1 font-medium text-sm xl:pt-3 xl:pb-8">
              <span className="flex flex-row items-center gap-x-4">
                <div>
                  <Check />
                </div>
                6 Premium accounts for family members living under one roof
              </span>

              <span className="flex flex-row items-center gap-x-4">
                <div>
                  <Check />
                </div>
                Block explicit music
              </span>

              <span className="flex flex-row items-center gap-x-4">
                <div>
                  <Check />
                </div>
                Ad-free music listening, play offline, play songs in any order
              </span>
            </div>

            <div className="flex flex-col gap-y-4">
              <button className="w-full bg-black text-white px-5 py-3 sm:py-4 md:py-3 rounded-3xl text-sm font-semibold uppercase hover:transform translate duration-800 hover:scale-105">
                <Link to="/"> Get Started</Link>
              </button>

              <p className="text-black font-medium text-xs sm:text-xs lg:text-[0.6rem]">
                <span className="underline cursor-pointer mr-1">
                  <Link to="/">Terms and conditions apply.</Link>
                </span>
                1 month free not available for users who already have premium
              </p>
            </div>
          </div>

          <div className="bg-white flex flex-col gap-y-6 lg:gap-y-4 xl:gap-y-1 py-5 px-5 border-2 border-solid rounded-xl shadow-2xl lg:shadow-xs xl:h-[33rem]">
            <div>
              <div className="flex flex-col gap-1 text-sm sm:flex-row md:gap-2 lg:flex-col">
                <p className="w-fit bg-blue-700 text-white font-semibold p-1 rounded-md ">
                  1 month free with subscription
                </p>
                <p className="w-fit text-blue-700 font-semibold p-1 border-blue-700 border-solid border-[.1rem] rounded-md ">
                  Prepaid plans available
                </p>
              </div>

              <div className="font-medium text-sm flex flex-col gap-y-[.1rem] py-4">
                <h1 className="font-bold text-lg">Student</h1>
                <p>₦ 450/month after offer period</p>
                <p>1 account</p>
              </div>

              <hr className="border-[0.1rem] border-gray-600 drop-shadow-xl opacity-70" />
            </div>

            <div className="flex flex-col justify-center gap-2 xl:gap-1 font-medium text-sm xl:pt-3 xl:pb-[2.85rem]">
              <span className="flex flex-row items-center gap-x-4">
                <div>
                  <Check />
                </div>
                Special discount for eligible students in university
              </span>

              <span className="flex flex-row items-center gap-x-4">
                <div>
                  <Check />
                </div>
                Ad-free music listening
              </span>

              <span className="flex flex-row items-center gap-x-4">
                <div>
                  <Check />
                </div>
                Play anywhere - even offline
              </span>
              <span className="flex flex-row items-center gap-x-4">
                <div>
                  <Check />
                </div>
                Play songs in any order
              </span>
            </div>

            <div className="flex flex-col gap-y-4">
              <button className="w-full bg-black text-white px-5 py-3 sm:py-4 md:py-3 rounded-3xl text-sm font-semibold uppercase hover:transform translate duration-800 hover:scale-105">
                <Link to="/"> Get Started</Link>
              </button>

              <p className="text-black font-medium text-xs sm:text-xs lg:text-[0.6rem]">
                <span>
                  Offer available only to students at an accredited higher
                  education institution. 1 month free not available to users who
                  already tried Premium. Spotify Student Discount Offer{" "}
                  <Link className="underline cursor-pointer mr-1" to="/">
                    Terms and conditions apply.
                  </Link>
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Premium;
